import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';

export const productRecommendationApi = createApi({
  reducerPath: 'recommendationApiSlice',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
  }),
  endpoints: (builder) => ({
    getCropOptions: builder.query({
      query: () => 'crops',
    }),
    getLevelOptions: builder.query({
      query: () => 'levels',
    }),
    getInfestationOptions: builder.query({
      query: () => 'infestations',
    }),
    getClientOptions: builder.query({
      query: () => 'clients',
    }),
    submitRecommendation: builder.mutation({
      query: (newRecommendation) => ({
        url: 'recommendations',
        method: 'POST',
        body: newRecommendation,
      }),
    }),
    getRecommendations: builder.query({
      query: (productId) => `recommendations?productId=${productId}`,
    }),
    updateRecommendations: builder.mutation({
      query: ({ productId, recommendations }) => ({
        url: `recommendations/${productId}`,
        method: 'PUT',
        body: { recommendations },
      }),
    }),
  }),
});

export const {
  useGetCropOptionsQuery,
  useGetLevelOptionsQuery,
  useGetInfestationOptionsQuery,
  useGetClientOptionsQuery,
  useSubmitRecommendationMutation,
  useGetRecommendationsQuery,
  useUpdateRecommendationsMutation,
} = productRecommendationApi;
